// frontend/src/components/home/ContentTabs.js

import { useRef, useState } from "react";

import UpdateAccordion from "./UpdateAccordion";

export default function ContentTabs() {
  const [activeTab, setActiveTab] = useState(null);
  const [closingTab, setClosingTab] = useState(null);

  const panelRef = useRef(null);

  const tabs = [
    {
      id: "about",
      label: "ABOUT GAME",
    },
    {
      id: "updates",
      label: "UPDATE NOTES",
    },
    {
      id: "creator",
      label: "ABOUT CREATOR",
    },
  ];

  function scrollToPanel() {
    setTimeout(() => {
      panelRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 80);
  }

  function scrollBackToButtons() {
    setTimeout(() => {
      document.querySelector(".content-tabs")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 180);
  }

  function handleTabClick(tabId) {
    if (activeTab === tabId) {
      setClosingTab(activeTab);

      setTimeout(() => {
        setActiveTab(null);
        setClosingTab(null);
        scrollBackToButtons();
      }, 220);

      return;
    }

    setActiveTab(tabId);
    setClosingTab(null);
    scrollToPanel();
  }

  function renderContent(tabId) {
    switch (tabId) {
      case "about":
        return (
          <div className="tab-content-text">
            <h2>A Different Life Begins With a Letter</h2>

            <p>
              You are someone who feels stuck, disconnected from your friends,
              your work, and your life. One day, you come home and find a
              strange letter waiting at your door.
            </p>

            <p>
              On the outside, it says:{" "}
              <em>“If you want a different life… open it.”</em>
            </p>

            <p>
              Curiosity wins. You open the letter, a flash of light appears, and
              you wake up in another world.
            </p>

            <h2>An Open World Full of Secrets</h2>

            <p>
              Elacoria is an open-world survival sandbox RPG where you can dig
              deep underground, uncover ancient ruins, and discover secrets
              hidden beneath the world.
            </p>

            <p>
              You can also climb into the sky and explore floating islands
              inspired by the sense of adventure from One Piece.
            </p>

            <p>
              The world is filled with different biomes, dynamic weather,
              changing seasons, and dangers that do not care whether you
              survive.
            </p>

            <h2>Survive, Build, Fight, and Grow</h2>

            <p>
              Gather food, collect materials, craft tools, build your own
              shelter, and fight against nature itself.
            </p>

            <p>
              You will meet NPCs, bosses, and other people who were brought to
              this world just like you. Some may become friends, some may become
              enemies, and some may become something more.
            </p>

            <p>
              Fight Elmons or tame them so they can help you work, explore, and
              fight. Upgrade your gear, build your stats, grow stronger, and
              uncover why you were brought here.
            </p>
          </div>
        );

      case "updates":
        return <UpdateAccordion />;

      case "creator":
        return (
          <div className="tab-content-text">
            <h2>Made by a Solo Indie Developer</h2>

            <p>Hi, I'm Lightborn68.</p>

            <p>
              I've spent the last few years building Elacoria mostly solo using
              Unreal Engine 5.
            </p>

            <p>
              My goal is to create a world that feels mysterious, immersive, and
              full of adventure — a world players can truly get lost in.
            </p>

            <p>
              From programming and world generation to art direction and game
              design, this project is being crafted with passion, curiosity, and
              a love for sandbox games.
            </p>

            <p>Thank you for being here and supporting the journey.</p>
          </div>
        );
      default:
        return null;
    }
  }

  const visibleTab = closingTab || activeTab;
  const isClosing = Boolean(closingTab);

  return (
    <div className="content-tabs">
      <div className="content-tab-buttons">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id && !isClosing;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={
                isActive ? "content-tab-button active" : "content-tab-button"
              }
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {visibleTab && (
        <div
          ref={panelRef}
          className={
            isClosing
              ? "content-tab-panel tab-closing"
              : "content-tab-panel tab-opening"
          }
        >
          {renderContent(visibleTab)}
        </div>
      )}
    </div>
  );
}
